import * as React from 'react';
import { connect } from 'react-redux';

import { Column, ColumnsContainer, Row } from '../markup';
import { Dispatch, IAppState } from '../../../../common/state';
import { getTermsValue } from '../../../../json_query/reducers/helpers';
import { pushTermsValue, removeTermsValue } from '../../../state/advanced/terms';
import { CheckboxListItem, ICheckboxListProps } from './abstract_params/checkbox_list_item';
import { EAmenityType } from '../../../../repositories/common/json_query';
import { amenityMap } from '../../tags/items/amenity';

export type TAmenityParam = { key: string; text: string; value: number };
const params: Array<TAmenityParam[]> = [
  [
    { key: 'wifi', text: amenityMap[EAmenityType.Wifi], value: EAmenityType.Wifi },
    { key: 'bikeParking', text: amenityMap[EAmenityType.BikeParking], value: EAmenityType.BikeParking },
    { key: 'internet', text: amenityMap[EAmenityType.Internet], value: EAmenityType.Internet },
    { key: 'restZone', text: amenityMap[EAmenityType.RestZone], value: EAmenityType.RestZone },
    { key: 'cafe', text: amenityMap[EAmenityType.Cafe], value: EAmenityType.Cafe },
    { key: 'cleaning', text: amenityMap[EAmenityType.Cleaning], value: EAmenityType.Cleaning },
    { key: 'kitchen', text: amenityMap[EAmenityType.Kitchen], value: EAmenityType.Kitchen },
    { key: 'furniture', text: amenityMap[EAmenityType.Furniture], value: EAmenityType.Furniture },
  ],
  [
    { key: 'security', text: amenityMap[EAmenityType.Security], value: EAmenityType.Security },
    { key: 'parking', text: amenityMap[EAmenityType.Parking], value: EAmenityType.Parking },
    { key: 'meetingRoom', text: amenityMap[EAmenityType.MeetingRoom], value: EAmenityType.MeetingRoom },
    { key: 'printer', text: amenityMap[EAmenityType.Printer], value: EAmenityType.Printer },
    { key: 'reception', text: amenityMap[EAmenityType.Reception], value: EAmenityType.Reception },
    { key: 'modern', text: amenityMap[EAmenityType.Modern], value: EAmenityType.Modern },
    { key: 'gym', text: amenityMap[EAmenityType.Gym], value: EAmenityType.Gym },
    { key: 'phoneBooth', text: amenityMap[EAmenityType.PhoneBooth], value: EAmenityType.PhoneBooth },
  ],
  [
    { key: 'techSupport', text: amenityMap[EAmenityType.TechSupport], value: EAmenityType.TechSupport },
    { key: 'events', text: amenityMap[EAmenityType.Events], value: EAmenityType.Events },
    { key: 'fax', text: amenityMap[EAmenityType.Fax], value: EAmenityType.Fax },
    { key: 'flipchart', text: amenityMap[EAmenityType.Flipchart], value: EAmenityType.Flipchart },
    { key: 'fruits', text: amenityMap[EAmenityType.Fruits], value: EAmenityType.Fruits },
    { key: 'tea', text: amenityMap[EAmenityType.Tea], value: EAmenityType.Tea },
    { key: 'lockers', text: amenityMap[EAmenityType.Lockers], value: EAmenityType.Lockers },
    { key: 'legalAddress', text: amenityMap[EAmenityType.LegalAddress], value: EAmenityType.LegalAddress },
  ],
];

export interface IAmenitiesProps {
  selected: number[];
  select(value: number): () => void;
  deselect(value: number): () => void;
}

// tslint:disable-next-line:no-any
export const Amenities: React.StatelessComponent<IAmenitiesProps> = props => {
  const { selected, select, deselect } = props;

  return (
    <Row title="Включено в стоимость">
      <ColumnsContainer>
        {params.map((paramsColumn, index) => (
          <Column key={String(index)}>
            {paramsColumn.map(param => {
              const { key, text, value } = param;
              const isSelected = selected.includes(value);
              const props: ICheckboxListProps = {
                isSelected,
                select,
                deselect,
                text,
                value,
              };

              return <CheckboxListItem key={key} {...props} />;
            })}
          </Column>
        ))}
      </ColumnsContainer>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    selected: getTermsValue('amenity')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    select: (value: number) => () => {
      dispatch(pushTermsValue('amenity')(value));
    },
    deselect: (value: number) => () => {
      dispatch(removeTermsValue('amenity')(value));
    },
  }),
)(Amenities);
